// 配列化
export function parseJsonArray (v) {
  if (Array.isArray(v)) return v
  if (typeof v === 'string' && v.trim() !== '') {
    try {
      const parsed = JSON.parse(v)
      return Array.isArray(parsed) ? parsed : []
    } catch (e) {
      return []
    }
  }
  return []
}

function toBool (v) {
  return v === true || v === 1 || v === '1' || v === 'true'
}

// detail_info / フラット両対応の正規化（共通化）
export function normalizeCampaignRow (row) {
  const src = (row && typeof row.detail_info === 'object')
    ? Object.assign({}, row, row.detail_info)
    : (row || {})

  return {
    condition_id: Number((row && row.condition_id != null ? row.condition_id : src.condition_id)) || null,
    is_web_app: toBool(row && row.is_web_app),

    client_id: src.client_id || (row && row.client_id) || '',
    dialog_name: src.dialog_name || (row && row.dialog_name) || '',
    permission_type:
      row && row.permission_type != null
        ? Number(row.permission_type)
        : (src.permission_type != null ? Number(src.permission_type) : null),

    company_name: String(src.company_name || ''),

    start_age: src.start_age != null ? Number(src.start_age) : NaN,
    end_age: src.end_age != null ? Number(src.end_age) : NaN,
    prefectures: parseJsonArray(src.prefectures),
    keyword: parseJsonArray(src.keyword),
    exclude_keyword: parseJsonArray(src.exclude_keyword),

    template_ids: parseJsonArray(src.template_ids),
    grade_year: src.grade_year,
    limit_date_flag: String((row && row.limit_date_flag) || src.limit_date_flag || '0'),
    request_able: !!((row && row.request_able) || src.request_able),
    request_count: Number((row && row.request_count) || src.request_count || 0),
    privacy_url: src.privacy_url || '',
    terms_url: src.terms_url || '',
    client_condition_id: src.client_condition_id || '',
    is_duplicate: String((row && row.is_duplicate) || src.is_duplicate || '0')
  }
}

// 住所 + 年齢 必須、keyword / exclude_keyword 任意
// 年齢は [start_age, end_age] の両端含む
export function checkCampaign ({
  prefectures,
  start_age,
  end_age,
  keyword = [],
  exclude_keyword = [],
  basicData,
  formatData,
  addressCheck,
  keywordCheckRirekisho,
  template_ids,
  formatId
}) {
  // 住所
  if (!Array.isArray(prefectures) || prefectures.length === 0) return false
  if (!addressCheck(basicData, prefectures)) return false

  // 年齢（両端含む）
  const age = (basicData && basicData.age != null) ? Number(basicData.age) : NaN
  if (!Number.isFinite(age) || !Number.isFinite(start_age) || !Number.isFinite(end_age)) return false
  if (age < Number(start_age) || age > Number(end_age)) return false

  // キーワード（指定があれば必須）
  if (Array.isArray(keyword) && keyword.length > 0) {
    if (!keywordCheckRirekisho(formatData, keyword)) return false
  }

  // NGキーワード（指定があればヒットで不合格）
  if (Array.isArray(exclude_keyword) && exclude_keyword.length > 0) {
    if (keywordCheckRirekisho(formatData, exclude_keyword)) return false
  }

  // テンプレート
  if (Array.isArray(template_ids) && template_ids.length > 0) {
    if (!formatId) return false
    if (!template_ids.includes(formatId)) return false
  }

  return true
}

//  API/モックの row を受けて check_result を付与して返す（detail_info対応）
//  is_web_app が true のものだけチェック対象
export function checkCampaignFromDbRow (row, ctx) {
  const src = normalizeCampaignRow(row)

  let result = false
  if (src.is_web_app === true) {
    result = checkCampaign({
      prefectures: src.prefectures,
      start_age: src.start_age,
      end_age: src.end_age,
      keyword: src.keyword,
      exclude_keyword: src.exclude_keyword,
      basicData: ctx.basicData,
      formatData: ctx.formatData,
      addressCheck: ctx.addressCheck,
      keywordCheckRirekisho: ctx.keywordCheckRirekisho,
      template_ids: src.template_ids,
      formatId: ctx.formatId
    })
  }

  // 元の row に check_result を付けて返す
  row.check_result = result
  return row
}

// ローカルモックの配列を一括チェック
export function checkCampaignFromMockRows (rows, ctx) {
  const list = Array.isArray(rows) ? rows : Object.values(rows || {})
  return list.map(r => checkCampaignFromDbRow(r, ctx))
}

// 使い方サンプル
// 実運用では runSample() は呼ばず、API結果に対して
// checkCampaignFromMockRows(...) を使う予定

// サンプル：住所チェック関数（optional chaining なし）
export function sampleAddressCheck (basicData, allowed) {
  const pref = (basicData && basicData.prefecture) ? basicData.prefecture : null
  if (!pref || !Array.isArray(allowed)) return false
  return allowed.indexOf(pref) !== -1
}

// サンプル：履歴書キーワードチェック（optional chaining なし）
export function sampleKeywordCheckRirekisho (formatData, words) {
  const text = (formatData && typeof formatData.text === 'string') ? formatData.text : ''
  const haystack = String(text).toLowerCase()
  return Array.isArray(words) && words.some(w => haystack.includes(String(w || '').toLowerCase()))
}

/**
 * サンプル: コンテキスト生成
 */
export function makeSampleContext () {
  return {
    basicData: {
      age: 40,
      prefecture: '東京都'
    },
    formatData: {
      text: '自己PR: 看護師として15年間、病院やクリニックで勤務し、幅広い診療科で経験を積みました。'
    },
    addressCheck: sampleAddressCheck,
    keywordCheckRirekisho: sampleKeywordCheckRirekisho
  }
}

/**
 * サンプル: 行データ（detail_info/フラット混在）
 * - 実運用ではAPIの返却をそのまま渡す
 */
export function makeSampleRows () {
  return [
    {
      id: 1,
      is_web_app: true,
      company_name: '株式会社A',
      start_age: 20,
      end_age: 29,
      prefectures: ['東京都', '神奈川県'],
      keyword: ['看護師', '東京'],
      exclude_keyword: ['営業']
    },
    // detail_info型（文字列JSONを含むケース）
    {
      id: 2,
      is_web_app: true,
      detail_info: {
        company_name: '株式会社B',
        start_age: 18,
        end_age: 35,
        prefectures: '["東京都","千葉県"]',
        keyword: '["工業"]',
        exclude_keyword: '[]'
      }
    },
    // is_web_app が false → 判定スキップ
    {
      id: 3,
      is_web_app: false,
      company_name: '株式会社C',
      start_age: 22,
      end_age: 30,
      prefectures: ['東京都']
    }
  ]
}

/**
 * サンプル: 一括実行
 * - 実運用では以下のように:
 *   const ctx = { basicData, formatData, addressCheck, keywordCheckRirekisho }
 *   const enriched = checkCampaignFromMockRows(apiRows, ctx)
 */
export function runSample () {
  const ctx = makeSampleContext()
  const rows = makeSampleRows()
  const result = checkCampaignFromMockRows(rows, ctx)

  // デモ出力（ブラウザ/Node両対応想定）
  if (typeof console !== 'undefined') {
    console.log('[new-rt-system] sample input rows:', rows)
    console.log('[new-rt-system] checked result:', result.map(r => ({ id: r.id, check_result: r.check_result })))
  }

  return result
}

/**
 * 実API結果の加工サンプル
 * @param {Array<object>} apiRows - APIが返す row 配列
 * @param {object} ctx - { basicData, formatData, addressCheck, keywordCheckRirekisho }
 * @returns {Array<object>} check_result 付きの配列
 */
export function checkApiRows (apiRows, ctx) {
  return checkCampaignFromMockRows(apiRows, ctx)
}
